import {
  TBarcodeScannerLogColumnKey,
} from './debug-barcode-scanner.ts';

const columns: Record<TBarcodeScannerLogColumnKey, string> = {
  timestampEpochMilliseconds: 'Casova znacka',
  eventType: 'Udalost',
  characterLabel: 'Znak',
  isControlCharacter: 'Riadiaci znak',
  key: 'Klaves',
  code: 'Kod',
  keyCode: 'Kod klavesu',
  modifierList: 'Modifikatory',
  inputType: 'Typ vstupu',
  inputValueSnapshot: 'Hodnota pola',
};

export default {
  description: 'Kliknite do pola nizsie a naskenujte ciarovy kod, aby ste videli kazdu udalost klavesnice a vstupu, ktoru prehliadac vyvola, v poradi ich vyskytu. Najnovsia udalost sa zobrazuje v hornej casti zaznamu. Netlacitelne riadiace znaky sa zobrazuju pomocou ich standardnej skratky, napriklad <GS> pre znak Group Separator (0x1D).',
  scanInputPlaceholder: 'Kliknite sem a naskenujte ciarovy kod',
  eventCount: 'Zaznamenanych udalosti: {count}',
  copyLogButtonLabel: 'Kopirovat zaznam',
  clearButtonLabel: 'Vymazat',
  emptyLog: 'Zatial ziadne udalosti. Naskenujte ciarovy kod a spustite zaznamenavanie.',
  columns,
};
